// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeProjectsEditPage_wrapper__Jb9FR"};